//  export const BASE_URL = "http://hwaceri5:3011/api/"; 
// export const BASE_URL = "http://srv957718.hstgr.cloud:8061/api/";

export const Bunny_Storage_URL = "https://sg.storage.bunnycdn.com/thedreammomstoragezone";
export const Bunny_Storage_Access_Key = "ac996aa4-f8b4-4f38-9105483a2cd2-e17d-45e8";
export const Bunny_Stream_Access_Key = "fefcf79a-fbd0-4b50-96feb9589920-c855-4a5a";
export const Bunny_Stream_URL = "https://video.bunnycdn.com/library/662982/videos";
export const Bunny_Stream_GET_URL = "https://video.bunnycdn.com/embed";
export const Bunny_Image_URL = "https://theDreamMomPullZone.b-cdn.net";
export const Bunny_Thumbnail_URL="https://vz-f9761bfc-074.b-cdn.net";

export const BASE_URL = process.env.REACT_APP_BASE_URL;


// export const Bunny_Storage_URL = process.env.REACT_APP_BUNNY_STORAGE_URL;
// export const Bunny_Storage_Access_Key = process.env.REACT_APP_BUNNY_STORAGE_ACCESS_KEY;
// export const Bunny_Stream_Access_Key = process.env.REACT_APP_BUNNY_STREAM_ACCESS_KEY;
// export const Bunny_Stream_URL = process.env.REACT_APP_BUNNY_STREAM_URL;
// export const Bunny_Stream_GET_URL = process.env.REACT_APP_BUNNY_STREAM_GET_URL;
// export const Bunny_Image_URL = process.env.REACT_APP_BUNNY_IMAGE_URL;
// export const Bunny_Thumbnail_URL = process.env.REACT_APP_BUNNY_THUMBNAIL_URL;